// TES-442 — "Remissnummer i Webdoc (valfritt)": the remiss number the doctor
// may type beside "Provbeställning/remiss för blodprov är skapad i Webdoc", or later on the
// order itself. Optional, never required: a LabPortalen answer is matched by
// personnummer without it, and with it straight to the right order.
//
// The rule mirrors the API's (requisitionRefSchema in contracts): trimmed;
// letters, digits and dashes; at most 64 characters. Blank means none.
//
// Pure on purpose: no React, no path aliases (`node --test`).

const PATTERN = /^[A-Za-z0-9-]{1,64}$/;

/** The value to send: trimmed, or null when blank. */
export function normalizedRequisitionRef(raw: string): string | null {
  const t = raw.trim();
  return t === "" ? null : t;
}

/** The inline hint for an invalid value; null when blank or valid. */
export function requisitionRefError(raw: string): string | null {
  const t = normalizedRequisitionRef(raw);
  if (t === null || PATTERN.test(t)) return null;
  return t.length > 64
    ? "Högst 64 tecken."
    : "Endast bokstäver, siffror och bindestreck.";
}

/**
 * The part of a publish's `webdocControl` that carries the number: only
 * with the remiss row shown AND ticked, and only when something was typed.
 */
export function requisitionRefControl(s: {
  needsLabOrder: boolean;
  labOrderDone: boolean;
  requisitionRef?: string;
}): { labOrderRequisitionRef?: string } {
  const ref = normalizedRequisitionRef(s.requisitionRef ?? "");
  return s.needsLabOrder && s.labOrderDone && ref !== null
    ? { labOrderRequisitionRef: ref }
    : {};
}
